import { DetailsEditor } from "uikit"
import FaqLinks from "components/FaqLinks"
import React, { useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useStore } from "store"
import { incomeTypes } from "../incomeTypes"

const IncomeDetailsView = props => {
  const { household, type, onSubmit, onDelete, incomeId } = props
  useEffect(() => {
    window.trackEvent("edit-income", { type })
  }, [type])

  const { view: Worksheet } = incomeTypes[type]
  const [{ label, description, faqs = [] }] = useStore(
    "contextuals",
    `Income: ${type}`
  )
  const isNew = incomeId === "new"
  const heading = `${isNew ? "Add" : "Edit"} ${label}`
  function editor(income) {
    return (
      <DetailsEditor
        heading={heading}
        description={description}
        supplement={faqs.length ? <FaqLinks items={faqs} /> : null}
      >
        <Worksheet
          submit={async props => {
            await onSubmit(props)
            return
          }}
          onDelete={onDelete}
          household={household}
          success={<Redirect to="/organize/income+benefits" />}
          isNew={isNew}
          income={income}
        />
      </DetailsEditor>
    )
  }
  if (isNew) {
    return editor(null)
  }

  return <IncomeDetailsEditor incomeId={incomeId} editor={editor} />
}

const IncomeDetailsEditor = props => {
  const [income] = useStore("incomes", props.incomeId)
  return props.editor(income)
}

export default IncomeDetailsView
